import type { ShouldRevalidateFunction } from '@remix-run/react';

export const shouldRevalidateLoaderData: ShouldRevalidateFunction = ({
  nextUrl,
  currentUrl,
  defaultShouldRevalidate,
  formAction,
  formData,
}) => {
  const isCreatingLogin = formAction === '/create_login';

  const isRequestingMagicLink = formData?.get('request_magic_link') === 'true';

  if (isCreatingLogin && isRequestingMagicLink) {
    return false;
  }

  if (!isCreatingLogin) {
    const currentModalParamValue = currentUrl.searchParams.get('modal');
    const nextModalParamValue = nextUrl.searchParams.get('modal');
    const currentTabParamValue = currentUrl.searchParams.get('tab');
    const nextTabParamValue = nextUrl.searchParams.get('tab');
    const currentViewParamValue = currentUrl.searchParams.get('view');
    const nextViewParamValue = nextUrl.searchParams.get('view');

    const isPathnameTheSame = currentUrl.pathname === nextUrl.pathname;

    // Modal opening
    if (nextModalParamValue && isPathnameTheSame) {
      return false;
    }

    // Modal closing
    if (currentModalParamValue && !nextModalParamValue && isPathnameTheSame) {
      return false;
    }

    // Switching tabs
    if (nextTabParamValue && isPathnameTheSame) {
      return false;
    }

    // Going back to "manage"
    if (currentTabParamValue && !nextTabParamValue && isPathnameTheSame) {
      return false;
    }

    // Switching community feed view (?view=for_you|following)
    if (nextViewParamValue && isPathnameTheSame) {
      return false;
    }

    // Returning to default community feed view (clearing ?view=)
    if (currentViewParamValue && !nextViewParamValue && isPathnameTheSame) {
      return false;
    }
  }

  return defaultShouldRevalidate;
};
